// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1N4sybGL_LPJrW {\n  vertical-align: middle;\n  flex-flow: row;\n  display: flex;\n  padding: 8px 16px;\n  width: 100%;\n  cursor: pointer;\n  align-items: center;\n  background-color: rgba(9, 30, 66, 0.04);\n  box-sizing: border-box;\n}\n._1N4sybGL_LPJrW:hover {\n  background-color: rgba(9, 30, 66, 0.08);\n}\n._1N4sybGL_LPJrW:active {\n  background-color: #e4f0f6;\n}\n._1ZjtBFRfrlas2n {\n  display: inline-block;\n}\n._1c69KJQFXHIlXv {\n  margin: 4px;\n  min-width: 24px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inviteWorkspace": "_1N4sybGL_LPJrW",
	"inviteTeamText": "_1ZjtBFRfrlas2n",
	"orgIcon": "_1c69KJQFXHIlXv"
};
export default ___CSS_LOADER_EXPORT___;
